const locale = navigator.language;

function formatDate(date: Date) {
    if(typeof date === 'string') { date = new Date(date) };
    return date.toLocaleDateString(locale, { year: '2-digit', month: 'short', day: 'numeric' });
}

export default formatDate;